import { createContext, PropsWithChildren, useContext } from "react";

const IntegrationEnvironmentContext = createContext<string | null>(null);

export function IntegrationEnvironmentProvider({
  environmentId,
  children,
}: PropsWithChildren<{ environmentId?: string | null }>) {
  const value =
    typeof environmentId === "string" && environmentId.trim().length > 0
      ? environmentId.trim()
      : null;
  return (
    <IntegrationEnvironmentContext.Provider value={value}>
      {children}
    </IntegrationEnvironmentContext.Provider>
  );
}

export function useIntegrationEnvironmentIdOptional(): string | null {
  return useContext(IntegrationEnvironmentContext);
}
